"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.marksSubmissionApprovalsSchemaDef = exports.parentCentreSchemaDef = exports.toMarksSubmissionApprovalBusinessId = exports.MarksApprovalState = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
const __2 = require("../..");
const general_1 = require("../general");
const internal_1 = require("../internal");
var MarksApprovalState;
(function (MarksApprovalState) {
    MarksApprovalState["Approved"] = "APPROVED";
    MarksApprovalState["Rejected"] = "REJECTED";
    MarksApprovalState["Submitted"] = "SUBMITTED";
})(MarksApprovalState = exports.MarksApprovalState || (exports.MarksApprovalState = {}));
const toMarksSubmissionApprovalBusinessId = (params) => (Object.assign(Object.assign({}, (0, __1.toComponentBusinessId)(params)), { parentCentreId: params.parentCentreId }));
exports.toMarksSubmissionApprovalBusinessId = toMarksSubmissionApprovalBusinessId;
exports.parentCentreSchemaDef = {
    id: joi_1.default.string().required(),
    name: joi_1.default.string().required(),
};
exports.marksSubmissionApprovalsSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { businessUnitId: joi_1.default.string().required(), seriesId: joi_1.default.number().required(), assessment: joi_1.default.object({
        version: __1.assessmentSchemaDef.version,
        code: __1.assessmentSchemaDef.code,
        name: __1.assessmentSchemaDef.name,
    }).required(), componentNumber: joi_1.default.string().required(), componentName: joi_1.default.string().required(), centre: (0, __2.objectSchema)(__1.entryCentreSchemaDef).required(), parentCentre: (0, __2.objectSchema)(exports.parentCentreSchemaDef).required(), qualification: joi_1.default.object({
        id: internal_1.qualificationMinSchemaDef.id,
        name: internal_1.qualificationMinSchemaDef.name,
    }).required(), submissionDate: joi_1.default.string(), approvalsHistory: joi_1.default.array().items(joi_1.default.object({
        state: joi_1.default.string().valid(...Object.values(MarksApprovalState)),
        date: joi_1.default.string(),
        centreId: joi_1.default.string(),
        isFullSubmission: joi_1.default.boolean(),
    }).optional()) });
